// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2MS4h","info":"UpdateTermsInfo_info__14aHD"};